const flutterAuto = {
  en: {
    flutterAuto: {
      text1: 'Motor Vehicle',
      text2: 'Accident, Damage, Theft',
      text3: 'ACCIDENT',
      text4: 'Call',
      text5: 'Instruction',
      text6:
        'Instruction by the Compulsory Motor Vehicle Third Party Liability Insurance ',
      text7: 'Insurance case',
      text8: 'Accident, Theft, Damage',
      'acc1.title': '1. Provide first aid and assistance to injured persons.',
      'acc1.text1':
        'In the event of a traffic accident, please take actions that are reasonable under the current circumstances to reduce the potential for loss and damages and provide aid and assistance to the injured persons;',
      'acc2.title': '2. Report on the insurance event',
      'acc2.text1':
        'Please inform the authorities responsible for the insurance event and the persons involved (the traffic police, fire-fighting services, ambulance service, emergency services);',
      'acc3.title': '3. Notify the Insurance Company',
      'acc3.text1':
        'Immediately, but not later than within three working days after the occurrence of the insured event, please notify the Insurance Company. \n' +
        'Immediately, but not later than two working days from the date of notification of the insured event to the Insurance Company, please notify the injured party; allow the Insurance Company to transfer its right of recourse to the person responsible for the insured event.\n',
      'acc4.title': '4. Inform the injured party',
      'acc4.text1':
        'Please notify the injured party and the traffic police officers of the name of the Insurance Company with which the contract of compulsory motor liability insurance has been signed;',
      'acc5.title': '5. Undertake a medical examination',
      'acc5.text1':
        'Within two hours of receiving a written referral from an authorized officer, please undergo a medical examination to establish the fact of psychoactive substance use and state of intoxication in accordance with the legislation of the Republic of Kazakhstan;',
      'acc6.title': '6. List of documents',
      'acc6.text1':
        'The following documents should be attached to the application for receipt of the insurance benefit:',
      'acc6.text2':
        '1. A document confirming the fact of the insured event occurrence and the extent of damage caused to the injured party;',
      'acc6.text3':
        '2. Copy of certificate from health care organizations confirming the duration of temporary disability of the injured party, in case of harm caused to the life or health of the injured party, or certificate from specialized institutions confirming determination of disability of the injured party, if established;',
      'acc6.text4': "3. A notarized copy of the victim's death certificate;",
      'acc6.text5':
        "4. A document confirming the beneficiary's right to compensation for the harm (copy);",
      'acc6.text6':
        '5. A statement on determination of the extent of damage in the case envisaged by Article 22 (Item 3) of the Laws;',
      'acc6.text7':
        "6. A copy of the beneficiary's identity document (for a natural person) or the original of the power of attorney issued for the representative of the legal entity;",
      'acc6.text8':
        '7. Documents certifying the expenses incurred by the policyholder (insured) for the purpose of preventing or reducing the loss upon the occurrence of the insured event - if available.',
      input1:
        "Applicant's Name & Surname and Individual Identification Number (IIN)",
      input2: 'Phone Number',
      input3: 'Region',
      Almaty: 'Almaty',
      Astana: 'Astana',
      Taraz: 'Taraz',
      Shymkent: 'Shymkent',
      'Ust-Kamenogorsk': 'Ust-Kamenogorsk',
      Aktau: 'Aktau',
      Atyrau: 'Atyrau',
      Aktobe: 'Aktobe',
      Pavlodar: 'Pavlodar',
      Petropavlovsk: 'Petropavlovsk',
      Kokshetau: 'Kokshetau',
      Kyzylorda: 'Kyzylorda',
      Karaganda: 'Karaganda',
      Semey: 'Semey',
      Kostanay: 'Kostanay',
      Taldykorgan: 'Taldykorgan',
      Uralsk: 'Uralsk',
      Zheszkazgan: 'Zheszkazgan',
      input4: 'Choose a contract',
      input5: 'Search for the Insurance',
      input6: "Insured Person's IIN",
      input7: 'or',
      input8: 'Search',
      input9: 'Search results:',
      input10: 'Incident Date',
      input11: 'Brief description of the situation',
      input12: 'Fill in your name or IIN',
      next: 'Next',
      whatsapp: 'Write to WhatsApp',
      videoConf: 'Contact the Emergency Commissioner',
      videoConfText:
        'You can contact the emergency commissioner via video call by clicking the button below.',
      commissioner: 'Emergency Commissioner',
      openForm: 'Fill out the application',
    },
  },
  kz: {
    flutterAuto: {
      text1: 'Авто',
      text2: 'Апат, Зақымдау, Айдап әкету',
      text3: 'ЖКО',
      text4: 'Қоңырау',
      text5: 'Нұсқаулық',
      text6: 'КҚИ АҚЖМС нұсқаулығы',
      text7: 'Сақтандыру жағдайы',
      text8: 'ЖКО, Айдап әкету, Зақымдау',
      'acc1.title': '1. Зардап шеккен адамдарға көмек көрсетіңіз',
      'acc1.text1':
        'Көлік оқиғасы болған кезде ықтимал шығындар мен зиянды азайту үшін қалыптасқан жағдайларда ақылға қонымды шаралар қабылдаңыз және зардап шеккен адамдарға көмек көрсетіңіз;',
      'acc2.title': '2. Сақтандыру жағдайы туралы хабарлаңыз',
      'acc2.text1':
        'Тиісті органдарға (жол полициясы қызметкерлеріне, өртке қарсы қызметке, жедел медициналық жәрдем қызметіне, авариялық қызметтерге) сақтандыру жағдайы және зардап шеккен адамдар туралы хабарлаңыз;',
      'acc3.title': '3. Сақтандыру компаниясын хабардар етіңіз',
      'acc3.text1':
        'Сақтандыру жағдайы басталғаннан кейін шұғыл түрде, алайда үш жұмыс күнінен кешіктірмей Сақтандыру компаниясына хабарлаңыз. Сақтандыру компаниясын сақтандыру жағдайының басталғаны туралы хабардар еткеннен кейін екі жұмыс күнінен кешіктірмей бұл туралы жәбірленушіні хабардар етіңіз; Сақтандыру компаниясына сақтандыру жағдайының басталуына жауапты тұлғаға өзінің кері талап ету құқығының ауысуын ұсыныңыз.',
      'acc4.title': '4. Жәбірленушілерге хабарлаңыз',
      'acc4.text1':
        'Жәбірленушілер мен жол полициясы қызметкерлеріне көлік құралдары иелерінің жауапкершілігін міндетті сақтандыру шарты жасалған Сақтандыру компаниясының атауын хабарлаңыз;',
      'acc5.title': '5. Медициналық куәландырудан өтіңіз',
      'acc5.text1':
        'Уәкілетті лауазымды тұлғаның жазбаша жолдамасын алған сәттен бастап екі сағаттан кешіктірмей Қазақстан Республикасы заңнамасының талаптарына сәйкес психобелсенді заттарды пайдалану фактісін және масаң күйде болу жай-күйін анықтау үшін медициналық куәландырудан өтіңіз;',
      'acc6.title': '6. Құжаттар тізімі',
      'acc6.text1':
        'Сақтандыру төлемі туралы өтінішке мынадай құжаттар қоса беріледі:',
      'acc6.text2':
        '1. Сақтандыру жағдайының басталу фактісін және жәбірленушіге келтірілген зиянның мөлшерін растайтын құжат;',
      'acc6.text3':
        '2. Жәбірленушінің өміріне, денсаулығына зиян келтіру фактісі болған жағдайда жәбірленушінің еңбекке уақытша жарамсыздық мерзімі туралы денсаулық сақтау ұйымдарының анықтамасының немесе жәбірленушінің мүгедектігін белгілеу туралы мамандандырылған мекемелердің анықтамасының көшірмесі - ол анықталған жағдайда;',
      'acc6.text4':
        '3. Жәбірленушінің қайтыс болғаны туралы куәліктің нотариалды куәландырылған көшірмесі;',
      'acc6.text5':
        '4. Пайда алушының зиянды өтетуге құқығын растайтын құжат (көшірмесі);',
      'acc6.text6':
        '5. Заңның 22 - бабының 3-тармағында көзделген жағдайда зиянның мөлшерін айқындау туралы өтініш;',
      'acc6.text7':
        '6. Пайда алушының жеке куәлігінің көшірмесі (жеке тұлға үшін) немесе заңды тұлғаның өкіліне берілген сенімхаттың түпнұсқасы;',
      'acc6.text8':
        '7. Сақтандыру жағдайы басталған кезде шығындарды болдырмау немесе азайту мақсатында сақтанушының (сақтандырылушының) шеккен шығындарын растайтын құжаттар - олар болған кезде.',
      input1: 'Өтінішкердің  Т.А.Ә. және ЖСН',
      input2: 'Телефон нөмірі',
      input3: 'Өңір ',
      Almaty: 'Алматы',
      Astana: 'Астана',
      Taraz: 'Тараз',
      Shymkent: 'Шымкент',
      'Ust-Kamenogorsk': 'Өскемен',
      Aktau: 'Ақтау',
      Atyrau: 'Атырау',
      Aktobe: 'Ақтөбе',
      Pavlodar: 'Павлодар',
      Petropavlovsk: 'Петропавловск',
      Kokshetau: 'Көкшетау',
      Kyzylorda: 'Қызылорда',
      Karaganda: 'Қарағанды',
      Semey: 'Семей',
      Kostanay: 'Қостанай',
      Taldykorgan: 'Талдықорган',
      Uralsk: 'Орал',
      Zheszkazgan: 'Жезқазған',
      input4: 'Шартты таңдаңыз',
      input5: 'Сақтандыру шартын іздеу',
      input6: 'Сақтанушының ЖСН',
      input7: 'немесе',
      input8: 'Іздеу',
      input9: 'Іздеу нәтижесі:',
      input10: 'Оқиғаның болған күні',
      input11: 'Жағдайдың қысқаша сипаттамасы',
      input12: 'Т.А.Ә. немесе ЖСН толтырыңыз',
      next: 'Одан әрі',
      whatsapp: 'WhatsApp-ға жазу',
      videoConf: 'Апаттық комиссармен байланысыңыз',
      videoConfText:
        'Төмендегі түймені басу арқылы бейне байланыс комиссарына хабарласа аласыз',
      commissioner: 'Апаттық комиссар',
      openForm: 'Мәлімдеме толтыру',
    },
  },
  ru: {
    flutterAuto: {
      text1: 'Авто',
      text2: 'Авария, Повреждение, Угон',
      text3: 'ДТП',
      text4: 'Звонок',
      text5: 'Инструкция',
      text6: 'Инструкция ОГПО ВТС',
      text7: 'Страховой случай',
      text8: 'ДТП, Угон, Повреждение',
      'acc1.title': '1. Окажите помощь пострадавшим лицам',
      'acc1.text1':
        'При совершении транспортного происшествия, примите разумные в сложившихся обстоятельствах меры, чтобы уменьшить возможные убытки и вред, и окажите помощь пострадавшим лицам;',
      'acc2.title': '2. Сообщите о страховом случае',
      'acc2.text1':
        'Сообщите в соответствующие органы о страховом случае и пострадавших лицах (сотрудникам дорожной полиции, в противопожарную службу, в службу скорой медицинской помощи, аварийные службы);',
      'acc3.title': '3. Уведомите Страховую компанию',
      'acc3.text1':
        'Незамедлительно, но не позднее трех рабочих дней, после наступления страхового случая, уведомите Страховую компанию. Незамедлительно, не позднее двух рабочих дней со дня сообщения Страховой компании о наступлении страхового случая, уведомите об этом потерпевшего; Предоставьте Страховой компании переход своего права обратного требования к лицу, ответственному за наступление страхового случая.',
      'acc4.title': '4. Сообщите потерпевшим',
      'acc4.text1':
        'Сообщите потерпевшим и сотрудникам дорожной полиции наименование Страховой компании, с которой заключен договор обязательного страхования ответственности владельцев транспортных средств;',
      'acc5.title': '5. Пройдите медицинское освидетельствование',
      'acc5.text1':
        'Не позднее двух часов с момента получения письменного направления уполномоченного должностного лица, пройдите медицинское освидетельствование для установления факта употребления психоактивных веществ и состояния опьянения в соответствии с требованиями законодательства Республики Казахстан;',
      'acc6.title': '6. Список документов',
      'acc6.text1':
        'К заявлению о страховой выплате прилагаются следующие документы:',
      'acc6.text2':
        '1. Документ, подтверждающий факт наступления страхового случая и размер вреда, причиненного потерпевшим;',
      'acc6.text3':
        '2. Копия справки организаций здравоохранения о сроке временной нетрудоспособности потерпевшего в случае наличия факта причинения вреда жизни, здоровью потерпевшего или справки специализированных учреждений об установлении инвалидности потерпевшего - в случае ее установления;',
      'acc6.text4':
        '3. Нотариально удостоверенная копия свидетельства о смерти потерпевшего;',
      'acc6.text5':
        '4. Документ, подтверждающий право выгодоприобретателя на возмещение вреда (копия);',
      'acc6.text6':
        '5. Заявление об определении размера вреда в случае, предусмотренном пунктом 3 статьи 22 Закона;',
      'acc6.text7':
        '6. Копия удостоверения личности выгодоприобретателя (для физического лица) или оригинал доверенности, выданной представителю юридического лица;',
      'acc6.text8':
        '7. Документы, подтверждающие расходы, понесенные страхователем (застрахованным) в целях предотвращения или уменьшения убытков при наступлении страхового случая, - при их наличии.',
      input1: 'ФИО и ИИН Заявителя',
      input2: 'Номер телефона',
      input3: 'Регион происшествия',
      Almaty: 'Алматы',
      Astana: 'Астана',
      Taraz: 'Тараз',
      Shymkent: 'Шымкент',
      'Ust-Kamenogorsk': 'Усть-Каменогорск',
      Aktau: 'Актау',
      Atyrau: 'Атырау',
      Aktobe: 'Актобе',
      Pavlodar: 'Павлодар',
      Petropavlovsk: 'Петропавловск',
      Kokshetau: 'Кокшетау',
      Kyzylorda: 'Кызылорда',
      Karaganda: 'Караганда',
      Semey: 'Семей',
      Kostanay: 'Костанай',
      Taldykorgan: 'Талдыкорган',
      Uralsk: 'Уральск',
      Zheszkazgan: 'Жезказган',
      input4: 'Выберите договор',
      input5: 'Поиск договора страхования',
      input6: 'ИИН Застрахованного',
      input7: 'или',
      input8: 'Поиск',
      input9: 'Результат поиска:',
      input10: 'Дата происшествия',
      input11: 'Краткое описание ситуации',
      input12: 'Заполните ФИО или ИИН',
      next: 'Далее',
      whatsapp: 'Написать в WhatsApp',
      videoConf: 'Связаться с аварийным комиссаром',
      videoConfText:
        'Вы можете связаться с аварийным комиссаром по видеосвязи нажав на кнопку ниже',
      commissioner: 'Аварийный комиссар',
      openForm: 'Заполнить заявку',
    },
  },
};

export default flutterAuto;
